import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../components/form/elements/button';
import css from '../view.module.css';
import Text from '../../../../../components/form/elements/text';
import TextArea from '../../../../../components/form/elements/text-area';
import Form, { SubmitType } from '../../../../../components/form';
import { useParams } from 'react-router';
import * as yup from 'yup';
import { useService } from '../../../../../services/services';
import Group from '../../../../../components/form/elements/group';
import AnimalNote from '../../../../../interfaces/animal-note';

interface Props {
  notes: AnimalNote;
  setChosenEditNoteId: Dispatch<SetStateAction<string>>;
  setChosenNoteId: Dispatch<SetStateAction<string>>;
  update: boolean;
  setUpdate: Dispatch<SetStateAction<boolean>>;
}

export default function EditNotesForm({
  notes,
  setChosenEditNoteId,
  setChosenNoteId,
  update,
  setUpdate,
}: Props) {
  const { farmId, id } = useParams<{ farmId: string; id: string }>();
  const { t } = useTranslation();

  const transKeyPrefix = 'pages.livestock.animals_and_events.animals';
  const { animalService } = useService();
  const [body, setBody] = useState([]);
  const [footer, setFooter] = useState([]);

  useEffect(() => {
    setFooter([
      Button('save', null, '', null, '', true),
      Button('cancel', (el) => setChosenEditNoteId(''), '', null, '', true),
    ]);
  }, [setChosenEditNoteId]);

  const schema = yup.object().shape({
    title: yup.string().max(250),
    content: yup.string().required(),
  });

  useEffect(() => {
    setBody([
      Group(
        [
          Text('title', '', null, {
            isNoteForm: true,
            inline: true,
            placeholder: t(`${transKeyPrefix}.enter_note_tittle`),
          }),
          TextArea(
            'content',
            '',
            5,
            true,
            t(`${transKeyPrefix}.write_note_here`),
            true
          ),
        ],
        '',
        false,
        true
      ),
    ]);
  }, [t]);

  const submit = useCallback<SubmitType<AnimalNote>>(
    (form) => {
      return [
        animalService.updateNote(farmId, id, notes.id, form),
        (response) => {
          setChosenEditNoteId('');
          setChosenNoteId('');
          setUpdate(!update);
        },
      ];
    },
    [
      animalService,
      farmId,
      id,
      notes,
      setChosenEditNoteId,
      setChosenNoteId,
      setUpdate,
      update,
    ]
  );

  notes.title = notes?.title ?? '';

  return (
    <div className={css['note-form']}>
      <div>
        <Form
          title=""
          hideHeader={true}
          backTo={null}
          mode="create"
          body={body}
          values={notes}
          footer={footer}
          className="note-form"
          submit={submit}
          schema={schema}
        />
      </div>
    </div>
  );
}
